export class PropertyHelper {
    public static getValueFromClassProperty(propertyName: string, classInstance: any): any {
        if (propertyName.indexOf(".") === -1)
            return classInstance[propertyName];

        const splittedObject = propertyName.split(".");

        return this.getValueFromComplexObject(splittedObject, 0, classInstance);
    }

    public static getValueFromComplexObject(splittedObject: string[], index: number = 0, object?: any): any {
        if (index >= splittedObject.length)
            return object;

        index += 1;

        if(!object)
            return "";

        return this.getValueFromComplexObject(splittedObject, index, object[splittedObject[index - 1]]);
    }

    public static isPropsValid(object: any): boolean {
        return Object.keys(object).find(key => object[key] && object[key].hasOwnProperty("IsValid") && object[key].IsValid == false) == null;
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/propertyHelper.ts